module.exports = __webpack_public_path__ + "img/Startseite-Unten_Woche_1.0a7f5b3e.png";